<div class="header-roles-content px-3">
	<div *ngFor="let zone of zones; trackBy: trackByCode"
		class="grey-text text-darken-3 d-flex align-items-center cursor-pointer roleAction"
		(click)="onZoneClick(zone.code)">
		<span>{{ zone.displayName }}</span>
	</div>
</div>
